"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReclaimAddressToJSON = exports.ReclaimAddressFromJSONTyped = exports.ReclaimAddressFromJSON = void 0;
var runtime_1 = require("../runtime");
function ReclaimAddressFromJSON(json) {
    return ReclaimAddressFromJSONTyped(json, false);
}
exports.ReclaimAddressFromJSON = ReclaimAddressFromJSON;
function ReclaimAddressFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'salutation': !(0, runtime_1.exists)(json, 'salutation') ? undefined : json['salutation'],
        'honorific': !(0, runtime_1.exists)(json, 'honorific') ? undefined : json['honorific'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'additional': !(0, runtime_1.exists)(json, 'additional') ? undefined : json['additional'],
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'countryCode': json['countryCode'],
    };
}
exports.ReclaimAddressFromJSONTyped = ReclaimAddressFromJSONTyped;
function ReclaimAddressToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'salutation': value.salutation,
        'honorific': value.honorific,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'additional': value.additional,
        'street': value.street,
        'houseNumber': value.houseNumber,
        'zipCode': value.zipCode,
        'city': value.city,
        'countryCode': value.countryCode,
    };
}
exports.ReclaimAddressToJSON = ReclaimAddressToJSON;
//# sourceMappingURL=ReclaimAddress.js.map